import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=a9bd70f0&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=a9bd70f0&lang=scss&scoped=true"
import style1 from "./Language.vue?vue&type=style&index=1&id=a9bd70f0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bd70f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9bd70f0')) {
      api.createRecord('a9bd70f0', component.options)
    } else {
      api.reload('a9bd70f0', component.options)
    }
    module.hot.accept("./Language.vue?vue&type=template&id=a9bd70f0&scoped=true", function () {
      api.rerender('a9bd70f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Language.vue"
export default component.exports